import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";


const CheckboxRenderer = forwardRef((props, ref) => {

    const [checked, setChecked] = useState(!!props.value);

    useEffect(() => {
        setChecked(!!props.value);
    }, [props.value]);

    const onChangeStatus = (e) => {
        setChecked(e.target.checked);
        props.node.setDataValue(props.column.colId, e.target.checked);
    }

    useImperativeHandle(ref, () => ({
        refresh(params) {
            setChecked(!!params.getValue());
            return true;
        }
    }));

    return <span className="editableCell"><input onChange={onChangeStatus} type="checkbox" checked={checked} /></span>
});

export default CheckboxRenderer;
